import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { sizes } from '@atlaskit/icon';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var IconBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\twidth: ", ";\n\theight: ", ";\n\n\tbackground-color: ", ";\n\tborder-radius: 3px;\n\n\t& > svg,\n\t& > span[role='img'],\n\t& > span[role='presentation'] {\n\t\twidth: 83.333333%;\n\t}\n"])), function (props) {
  return sizes[props.size];
}, function (props) {
  return sizes[props.size];
}, function (props) {
  return props.color;
});